import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { dateOfBirth as dateOfBirthValidator } from '@klarna/mf-validations';

import { getStakeholders } from '@/selectors/merchant/stakeholders';
import { STAKEHOLDER_ROLES_V2, STAKEHOLDER_TYPES } from '@/containers/withStakeholderLogic';

const { APPLICANT } = STAKEHOLDER_ROLES_V2;

// Applicants with multiple roles
export const getSubmittedApplicants = createSelector(getStakeholders, stakeholders =>
  stakeholders.filter(s => s.roles.includes(APPLICANT) && s.roles.length > 1),
);

// Stakeholders to render in the applicant selector
export const getSelectableApplicantStakeholders = minAge =>
  createSelector(
    getStakeholders,
    getSubmittedApplicants,
    (stakeholders = [], submittedApplicants = []) =>
      mapStakeholder(
        submittedApplicants.concat(stakeholders.filter(s => !s.roles.includes(APPLICANT))),
        minAge,
      ),
  );

export const getAreAllTooYoung = minAge =>
  createSelector(
    getSelectableApplicantStakeholders(minAge),
    selectableStakeholders => !selectableStakeholders.some(s => s.isOldEnough),
  );

const isOldEnough = (dateOfBirth, minAge) => {
  const response = dateOfBirthValidator.validate(dateOfBirth, { minAge });
  return typeof response === 'boolean' ? response : !response.error;
};

const mapStakeholder = (stakeholders, minAge) =>
  stakeholders.map(stakeholder => {
    const dateOfBirth = _get(stakeholder, 'data.dateOfBirth', null);
    const region = _get(stakeholder, 'data.address.region', '');

    return {
      ...stakeholder,
      dateOfBirth,
      isOldEnough: isOldEnough(dateOfBirth, minAge),
      ...stakeholder.data,
      address: {
        region,
        ...stakeholder.data.address,
      },
      type: STAKEHOLDER_TYPES.PERSON,
    };
  });
